"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("@mui/material"),t=e.styled(e.FormHelperText)(()=>({marginTop:"8px",textAlign:"center"}));exports.HelperText=t;
